import { typeCheckAppModule } from "src/utils";
import { Subscriptions } from "./Subscriptions";

export const subscriptions = typeCheckAppModule({
    NAME: "subscriptions",
    Container: Subscriptions,
});
